var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-bottom":"50px"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.gheibats.gheibats,"headers":_vm.courseHeaders,"disable-pagination":true,"hide-default-footer":true,"no-data-text":_vm.tableText,"header-props":_vm.headerProps}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }